import React from 'react';

export const ModuleFeature = ({
  icon: IconComponent,
  title,
  description,
  reverse = false
}) => {
  return (
    <article
      className={`flex items-center gap-20 max-md:gap-16 max-sm:gap-10
        ${reverse ? "md:flex-row-reverse flex-col" : "md:flex-row flex-col"}
      `}
    >
      {/* Icon always first on mobile */}
      <div className="flex-shrink-0 w-[300px] max-md:w-[250px] max-sm:w-[200px]">
        <IconComponent />
      </div>

      <div className={`flex-1 ${reverse ? "md:text-right" : ""}`}>
        <h3 className="mb-4 text-3xl font-semibold leading-10 text-teal-600 max-sm:text-3xl max-sm:leading-9">
          {title}
        </h3>
        <p className="text-lg leading-7 text-gray-500 max-sm:text-base max-sm:leading-6">
          {description}
        </p>
      </div>
    </article>
  );
};
